import React from 'react';
import PlainText from 'ati-ui-react/components/PlainText';

import * as styles from './CommentTooltip.scss';
import { formatDateForComment } from '../../utils/formatDate';

const CommentTooltip = ({ comment }) => {
  const { addedDate, userName, comment: commentValue } = comment;
  return (
    <div className={styles.comment}>
      <PlainText
        size="small"
        className={styles.tooltipTitle}
      >
        {`${userName}, ${formatDateForComment(addedDate)}`}
      </PlainText>

      <PlainText
        size="small"
        className={styles.tooltipDetails}
      >
        {commentValue}
      </PlainText>
    </div>
  );
};

export default CommentTooltip;
